import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Animated, StyleSheet, View } from 'react-native';

import { lowerDisplayLineTestIDs, Theme } from '@constants';
import { useAirQuality, useShowNextLDLProduct } from '@hooks';

import { AirQualityDataType } from '../../../hooks/api/useGetAirQuality';
import { TWCAirQualityIcon } from '../../primitives/TWCAirQualityIcon/TWCAirQualityIcon';
import { TWCText } from '../../primitives/TWCText/TWCText';

const tPath = 'lowerDisplayLine.airQuality.';
const testIDPath = lowerDisplayLineTestIDs.airQuality;

const LDLAirQualityAPI = () => {
  const data = useAirQuality();
  const showNextProduct = useShowNextLDLProduct();

  useEffect(() => {
    !data && showNextProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return data ? <LDLAirQualityUI data={data} onFinish={showNextProduct} /> : <></>;
};

const LDLAirQualityUI = ({ data: { dataType, categoryIndex, descriptor }, onFinish }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const animatedValue = new Animated.Value(0);
    const animation = Animated.timing(animatedValue, {
      duration: 5000,
      useNativeDriver: true,
    });

    animation.start(({ finished }) => finished && onFinish?.());
    return animation.reset;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isToday = dataType === AirQualityDataType.Observation;
  const isTomorrow = dataType === AirQualityDataType.Forecast;

  return (
    <View style={styles.container}>
      <TWCText style={styles.productLabel} testID={testIDPath.productLabel} variant={'condensedText36Transparent'}>
        {isToday ? t(`${tPath}productLabelToday`) : isTomorrow ? t(`${tPath}productLabelTomorrow`) : null}
      </TWCText>
      <TWCAirQualityIcon categoryIndex={categoryIndex} testID={testIDPath.airQualityIcon} />
      <TWCText style={styles.airQualityDescriptor} testID={testIDPath.airQualityDescriptor} variant={'condensedText36'}>
        {descriptor}
      </TWCText>
    </View>
  );
};

export const LDLAirQuality = {
  API: LDLAirQualityAPI,
  UI: LDLAirQualityUI,
};

const styles = StyleSheet.create({
  airQualityDescriptor: {
    paddingLeft: Theme.px(18),
  },
  container: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  productLabel: {
    paddingRight: Theme.px(48),
  },
});
